module.exports = __webpack_public_path__ + "static/img/fullscreen-image_keep-on-top_600.3ee4a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_keep-on-top_600.png
// module id = 9J4u
// module chunks = 0